
















































import Vue from 'vue'
import { mapActions, mapState, mapMutations } from 'vuex'
import { NOTIFICA_ERRORE } from '../../../costanti'

export default Vue.extend({
    data: () => ({
        ubicazione: '',
        tipo_segnalazione: 1,
        categoria: 1,
        tipi_sengnalazione_per_categoria: [],
        descrizione: ''
    }),
    watch: {
        categoria: function(newValue) {
            this.tipi_sengnalazione_per_categoria = this.categorieSegnalazioni
                                                        .find(obj => { return obj.id === newValue })
                                                        .tipi_segnalazione
            this.tipo_segnalazione = this.tipi_sengnalazione_per_categoria[0].id
        }
    },
    computed: {
        ...mapState('reportMappa', ['centroMappa', 'categorieSegnalazioni']),
        ...mapState('user', ['userInfo']),
        ...mapState('upload', ['stagedFiles']),
        nuoviDati() {
            return {
                descrizione: this.descrizione,
                latitudine: this.centroMappa[1],
                longitudine: this.centroMappa[0],
                tipo_segnalazione_id: this.tipo_segnalazione,
                ubicazione: this.ubicazione,
                url_foto: this.stagedFiles.length > 0 ? this.stagedFiles[0].url : undefined
            }
        }
    },
    methods: {
        ...mapActions('modal', ['showModal', 'showNotification']),
        ...mapActions('reportAdmin', ['salvaSegnalazione']),
        ...mapMutations('upload', ['RESET_STAGED_FILES']),
        // metodo ricavare l indirizzo a partire dalle coordinate
        async getIndirizzoDaCoordinate() {
            try {
                const response = await Vue.axios.get('https://home.tecnograph-group.com/geocodermassivo/reversegeocode', {
                    params: {
                        longitudine: this.centroMappa[0],
                        latitudine: this.centroMappa[1]
                    }
                })
                console.log(response.data)
                if (!response.data.errore) this.ubicazione = response.data.indirizzoCompleto
                // nel caso la segnalazione sia fuori Ferrara impediamo l'inserimento
                if (response.data.comune && response.data.comune !== 'Ferrara') {
                    this.showModal(null)
                    this.showNotification({
                        name: NOTIFICA_ERRORE,
                        title: `Sono possibili segnalazioni solo nel comune di Ferrara`
                    })
                }

            } catch (err) {
                console.error(err)
            }
        },
        clientUpload(file) {
            this.$store.dispatch('upload/clientUpload', file)
        }

    },
    mounted() {
        this.RESET_STAGED_FILES()
        this.getIndirizzoDaCoordinate()
        this.tipi_sengnalazione_per_categoria = this.categorieSegnalazioni
                                                        .find(obj => { return obj.id === this.categoria })
                                                        .tipi_segnalazione

    }
})
